import { useState, useRef, useEffect } from "react";
// import { useSelector } from "react-redux";
// eslint-disable-next-line import/order
import PropTypes from "prop-types";

import "./BottomContentSideBar.css";

import { Modal } from "react-bootstrap";

import useLibrary from "@/features/Library/hooks/useLibrary";
import { useLibraryDocumentViewer } from "@/features/Library/context/LibraryDocumentViewerContext";

import UploadIcon from "../../../../public/bp_assets/img/cloud_icon.svg";
import incidentIcon from "../../../assets/images/incident.svg";
import { api_without_cancellation } from "../../../api/api";
import mixColorWithWhite from "../../TreatmentPage/utils/helperFn";
import TFIcon from "../../../Components/TreatmentPage/icon/treatment-first-icon-2.png";
import NewChatIcon from "../../../assets/NewChatIcon";
// import avatarImg from "../../../assets/images/avatar.svg";
// import UserChatBubble from "../../Forms/FirmUserBtn";
import powerbtn from "../../../assets/power-button.svg";
import useGetAISystem from "../../FirmSettings/ai-systems/hooks/useGetAISystem";
import { calculateAge, formatCalendarDate } from "../../../Utils/helper";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";

import ChatDocumentModal from "./ChatDocumentModal";
import DocumentRenameComponent from "./DocumentRenameComponent";
import BottomContentSideBar from "./BottomContentSideBar";
import RequestDocModal from "./RequestDocModal";
import LinkDocToTaskModal from "./LinkDocToTaskModal";
import { ProgressModal } from "./AISubmissionSuccessModal";
import LitigationDocumentMenu, { LitigationEventHeading } from "./LitigationDocumentMenu";
import avatarImage from "./../../../assets/images/avatar.svg";
export function toSentenceCase(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function UserProfile({ clientInfo }) {
  return (
    <>
      <div
        style={{
          width: "15px",
          height: "15px",
        }}
        className="user-profile-document-popup-img m-r-5 ic-15 d-flex align-items-center justify-content-center"
      >
        {clientInfo?.profile_pic_29p ? (
          <img
            src={clientInfo.profile_pic_29p}
            alt="Profile avatar ic-15 d-flex align-items-center justify-content-center"
            className=""
            style={{
              width: "15px",
              height: "15px",
            }}
          />
        ) : (
          <img
            style={{
              width: "15px",
              height: "15px",
              background: "var(--primary-30)",
            }}
            src={avatarImage}
            className="ic ic-avatar ic-15 has-avatar-icon d-flex align-items-center justify-content-center"
          />
        )}
      </div>

      <span
        className="clientTabFont d-flex align-items-center height-25"
        style={{ fontSize: "14px", fontWeight: "600" }}
      >
        {clientInfo
          ? `${clientInfo.last_name}${clientInfo.first_name ? `, ${clientInfo.first_name}` : ""}`
          : "Client Info"}
      </span>
    </>
  );
}

UserProfile.propTypes = {
  clientInfo: PropTypes.shape({
    profile_pic_29p: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
};

function PageInfo({ page, documentSlot, panel, file_name, clientInfo }) {
  const { page_icon = "", name = "" } = page || {};
  const hasLitigationEvent = page?.id === 19 && Boolean(panel);
  const insurancePartyMatch =
    name === "Insurance"
      ? panel?.panel_name?.match(/^(Client|Defendant|Witness|OtherParty)\b\s*/i)
      : null;
  const insuranceParty = insurancePartyMatch?.[1].toLowerCase();
  const insurancePartyIcon = {
    defendant: "ic-defendants",
    witness: "ic-witnesses",
    otherparty: "ic-parties",
  }[insuranceParty];
  const panelName = insurancePartyMatch
    ? panel.panel_name.slice(insurancePartyMatch[0].length)
    : panel?.panel_name;
  if (
    Object.keys(page || {}).length === 0 &&
    (documentSlot === null || documentSlot === undefined) &&
    panel === null
  ) {
    return null;
  }
  return (
    <div
      className="d-flex flex-column"
      style={{
        minHeight: "21px",
        maxHeight: hasLitigationEvent ? "84px" : "63px",
        width: "100%",
        fontWeight: "600",
      }}
    >
      <div
        className="text-bold p-l-5 d-flex align-items-center"
        style={{
          height: "21px",
          fontWeight: "600",
          gap: "5px",
        }}
      >
        <span className="">
          {page_icon && (
            <img
              src={page_icon}
              className="ic ic-15 d-flex align-items-center justify-content-center"
              alt=""
              style={{
                width: "15px",
                height: "15px",
              }}
            />
          )}
        </span>
        {name} Page
        {/* {documentSlot === null || documentSlot?.slot_number === 0 ? "Generally" : ""} */}
      </div>

      {documentSlot !== null &&
        documentSlot?.slot_number !== 0 &&
        documentSlot?.page?.name === "Treatment" && (
          <div
            className="text-bold p-l-5 p-r-5"
            style={{
              fontWeight: 600,
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                width: "100%",
                gap: "5px",
                background: mixColorWithWhite(panel?.specialty?.color, 10),
              }}
            >
              <span
                style={{
                  background: panel?.specialty?.color,
                  height: "21px",
                  width: "21px",
                  minWidth: "21px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {panel?.specialty?.name[0]}
              </span>

              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {panel?.panel_name}
              </span>
            </div>
          </div>
        )}

      {documentSlot?.page?.name !== "Treatment" && page?.panels && (
        <div
          className={`text-bold p-l-5 p-r-5${hasLitigationEvent ? " document-page-info-litigation-event" : ""}`}
          style={{
            fontWeight: 600,
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{
              width: "100%",
              gap: "5px",
            }}
          >
            {insuranceParty === "client" && (
              <img
                src={clientInfo?.profile_pic_29p || clientInfo?.profile_pic_19p || avatarImage}
                alt="Client"
                className="ic ic-15 flex-shrink-0"
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  background: "var(--primary-30)",
                }}
              />
            )}
            {insurancePartyIcon && (
              <i
                className={`ic ic-15 flex-shrink-0 ${insurancePartyIcon}`}
                role="img"
                aria-label={insurancePartyMatch[1]}
              />
            )}
            {hasLitigationEvent ? (
              <LitigationEventHeading panel={panel} showNumber={false} showStatus={false} />
            ) : (
              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {panelName}
              </span>
            )}
          </div>
        </div>
      )}

      {documentSlot !== null && documentSlot?.slot_number !== 0 && (
        <div
          className="text-bold p-l-5 p-r-5 d-flex align-items-center"
          style={{
            minHeight: "21px",
            fontWeight: 600,
            flex: 1,
            width: "100%",
            gap: "5px",
          }}
        >
          <span className="text-primary-25 text-center" style={{ width: "15px" }}>
            {documentSlot?.slot_number}.
          </span>
          <span
            style={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: !page?.panels ? "" : "nowrap",
            }}
          >
            {documentSlot?.slot_name === null ? file_name : documentSlot?.slot_name}
          </span>
        </div>
      )}
    </div>
  );
}

PageInfo.propTypes = {
  page: PropTypes.shape({
    page_icon: PropTypes.string,
    name: PropTypes.string,
  }),
  clientInfo: PropTypes.shape({
    profile_pic_29p: PropTypes.string,
    profile_pic_19p: PropTypes.string,
  }),
};

const DocumentModalSideBar = ({
  source,
  documentData,
  pages,
  slotsData,
  onRefetchSlotsData,
  loading,
  setSlotsData,
  setDeleteConfirmModal,
  refetchDocumentData,
  documentURL,
  firms,
  selectedFirm,
  users,
  chatLoading,
  chatError,
  handleSelectFirm,
  sendMessage,
  searchUsers,
  setChatDocumentThread,
  setUpdatedUser,
  handleSelectUser,
  hideDocumentModal2,
  isDisabled = false,
}) => {
  const {
    id: docId,
    for_client: clientInfo,
    for_case: caseInfo,
    file_name,
    attached_by: attachUser,
    document_slot: documentSlot,
  } = documentData;
  // const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  // console.log(slotsData);
  // const matchingSlot = slotsData.find((slot) =>
  //   slot.page_docs?.some((doc) => doc.id === documentData.id)
  // );
  // console.log(matchingSlot);

  // const matchExactSlott = matchingSlot?.page_docs?.find((doc) => doc.id === documentData.id);
  // console.log(matchExactSlott);
  // const panelWithDocument = matchingSlot?.panels?.find((panel) =>
  //   panel.documents?.some((doc) => doc.id === documentData?.id)
  // );
  // console.log(panelWithDocument);

  const matchingSlot = slotsData.find((item) => {
    if (!item.page?.panels) {
      return item.slots?.some((slot) => slot.docs?.some((doc) => doc.id === documentData.id));
    }
    const slot0 = item.slots?.find((slot) => slot.slot_number === 0);
    if (slot0?.docs?.some((doc) => doc.id === documentData.id)) {
      return true;
    }

    return [...(item.panels || []), ...(item.inactive_panels || [])].some((panel) =>
      panel.docs?.some((doc) => doc.id === documentData.id)
    );
  });

  // Find the exact slot/panel and document
  let matchExactSlott = null;
  let panelWithDocument = null;

  if (matchingSlot) {
    if (!matchingSlot.page?.panels) {
      for (const slot of matchingSlot.slots || []) {
        const foundDoc = slot.docs?.find((doc) => doc.id === documentData.id);
        if (foundDoc) {
          matchExactSlott = foundDoc;
          break;
        }
      }
    } else {
      // panels is true - check slot where slot_number === 0, then panels
      const slot0 = matchingSlot.slots?.find((slot) => slot.slot_number === 0);
      matchExactSlott = slot0?.docs?.find((doc) => doc.id === documentData.id);
      if (!matchExactSlott) {
        panelWithDocument = [
          ...(matchingSlot.panels || []),
          ...(matchingSlot.inactive_panels || []),
        ].find((panel) => panel.docs?.some((doc) => doc.id === documentData.id));
        if (panelWithDocument) {
          matchExactSlott = panelWithDocument.docs?.find((doc) => doc.id === documentData.id);
        }
      }
    }
  }

  const locationMaxHeight = matchingSlot?.page?.id === 19 && panelWithDocument ? "84px" : "63px";
  const { data: ai_sys } = useGetAISystem();

  const isTreatment =
    ai_sys?.is_medical_chronology_marked &&
    (matchExactSlott?.document_slot?.slot_number === 3 || documentSlot?.slot_number === 3) &&
    (matchExactSlott?.document_slot?.page?.name === "Treatment" ||
      documentSlot?.page?.name === "Treatment");
  const clientId = clientInfo?.id;
  const caseId = caseInfo?.id;
  const userId = attachUser?.id ? attachUser.id : localStorage.getItem("loggedInUser") || null;

  const [showMenuBar, setShowMenuBar] = useState(false);
  const [panelMenuBar, setPanelMenuBar] = useState(false);

  const [showDocLinkModal, setShowDocLinkModal] = useState(false);
  // const handShowDocLinkModal = () => setShowDocLinkModal(true);
  const handleShowDocLinkModalClose = () => setShowDocLinkModal(false);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    chatDoc: false,
    taskLink: false,
    docReview: false,
  });
  const dropdownRefs = {
    chatDoc: useRef(null),
    taskLink: useRef(null),
    docReview: useRef(null),
    addLib: useRef(null),
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.entries(dropdownRefs).forEach(([key, ref]) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropdownOpen((prev) => ({ ...prev, [key]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [documentPanelsData, setDocumentPanelsData] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const splitItemsIntoCol = (items) => {
    const totalItems = items.length;
    const midPoint = Math.ceil(totalItems / 2);

    return {
      leftCol: items.slice(0, midPoint),
      rightCol: items.slice(midPoint),
    };
  };

  const displayablePages = pages.filter((page) => {
    const slotData = slotsData?.find((slot) => slot?.page?.name === page?.name);
    return page?.is_notes_category && slotData && slotData.slots.length > 0;
  });

  const { leftCol, rightCol } = splitItemsIntoCol(displayablePages);
  const [aiSubmissionSuccess, setAISubmissionSuccess] = useState(false);
  const [aiSubmissionError, setAISubmissionError] = useState("");
  const handleAISubmission = async () => {
    setAISubmissionError("");

    try {
      const response = await api_without_cancellation.post("/api/general/extract-treatment-data/", {
        doc_id: docId,
        case_provider_id: panelWithDocument?.id,
      });

      if (response.status === 202) {
        setAISubmissionSuccess(true);
      }
    } catch (error) {
      console.error("AI Processing error:", error);
      setAISubmissionError(
        error.response?.data?.error ||
          error.response?.data?.message ||
          error.response?.data?.detail ||
          "Failed to send document for AI processing. Please try again."
      );
    }
  };
  const { updateDocument } = useLibrary();
  const { openDocument } = useLibraryDocumentViewer();

  const [librarySuccess, setLibrarySuccess] = useState(false);
  const [libraryDoc, setLibraryDoc] = useState(null);
  const [addingToLibrary, setAddingToLibrary] = useState(false);

  const handleDocToLib = async () => {
    if (addingToLibrary) return;
    setAddingToLibrary(true);
    try {
      const created = await updateDocument({ document_id: docId });
      const libDoc = created?.data ?? created;
      setLibraryDoc(libDoc);
      setLibrarySuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setAddingToLibrary(false);
    }
  };

  const openLibraryViewer = () => {
    setLibrarySuccess(false);
    if (libraryDoc) {
      hideDocumentModal2?.();
      openDocument(libraryDoc);
    }
  };

  const handleAttachLitigationDocument = async (slot, panel) => {
    const previousSlotData = slotsData;
    const updatedDocumentData = { ...documentData, document_slot: slot };
    const updatedSlotsData = slotsData.map((item) => {
      const isDestinationPage = item.page?.id === 19;
      const updatePanels = (panels) =>
        panels.map((currentPanel) => {
          const docs = (currentPanel.docs || []).filter((doc) => doc.id !== docId);
          if (isDestinationPage && panel && currentPanel.id === panel.id) {
            docs.push(updatedDocumentData);
          }
          return { ...currentPanel, docs };
        });

      return {
        ...item,
        slots: (item.slots || []).map((currentSlot) => {
          const docs = (currentSlot.docs || []).filter((doc) => doc.id !== docId);
          if (isDestinationPage && !panel && currentSlot.id === slot.id) {
            docs.push(updatedDocumentData);
          }
          return { ...currentSlot, docs };
        }),
        panels: updatePanels(item.panels || []),
        ...(item.inactive_panels && { inactive_panels: updatePanels(item.inactive_panels) }),
      };
    });

    try {
      setSlotsData(updatedSlotsData);
      await api_without_cancellation.post("api/doc/attach/", {
        panel_id: panel?.id ?? "",
        slot: slot.id,
        page_id: 19,
        case_id: documentData?.for_case?.id,
        panels: true,
        doc_id: docId,
        ...(panel?.event_type_id?.id && { event_type_id: panel.event_type_id.id }),
      });
      if (typeof refetchDocumentData === "function") {
        await refetchDocumentData();
      }
      onRefetchSlotsData();
    } catch (error) {
      console.error("Error attaching document to litigation", error);
      setSlotsData(previousSlotData);
    }
  };

  return (
    <div
      className={`right-sidebar d-flex flex-column ${pages?.length === 0 ? "document-action-sidebar" : ""}`}
      style={{
        width: pages?.length === 0 ? "35px" : "220px",
        zIndex: "1",
        minWidth: pages?.length === 0 ? "35px" : "220px",
      }}
    >
      {/*  */}
      <div className="bluish-effect" />
      <div
        className="d-flex flex-column justify-content-between h-100"
        style={{
          backgroundColor: "#f2f5f7",
        }}
      >
        <div>
          <span
            className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            CASE
          </span>
          <div
            className="client-name d-flex align-items-center side-bar-padding"
            style={{ height: "21px", background: "var(--primary-2)" }}
          >
            <UserProfile clientInfo={clientInfo} />
          </div>
          <div
            className="tile-row w-100 p-l-5 p-r-5 d-flex align-items-center justify-content-between"
            style={{ height: "21px", background: "var(--primary-4)" }}
          >
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                style={{ marginRight: "5px" }}
              >
                <img
                  src={birthdayIcon}
                  className=""
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
              </span>

              <p className="text-black font-weight-semibold d-block">
                {formatCalendarDate(clientInfo?.birthday)
                  ? formatCalendarDate(clientInfo?.birthday)
                  : clientInfo?.birthday || ""}
              </p>
            </div>
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className=" text-label  fw-bold d-flex align-items-center"
                style={{ marginRight: "5px", color: "var(--primary-25)", fontWeight: "600" }}
              >
                age
              </span>

              <p className="font-weight-semibold">{calculateAge(clientInfo?.birthday)}</p>
            </div>
          </div>
          <div
            className="tile-row w-100 p-l-5 p-r-5 d-flex flex-column align-items-start"
            style={{ height: "42px", background: "var(--primary-2)" }}
          >
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              {caseInfo?.case_type?.casetype_icon && (
                <span
                  className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                  style={{ marginRight: "5px" }}
                >
                  <img
                    style={{
                      width: "15px",
                      height: "15px",
                    }}
                    src={caseInfo?.case_type?.casetype_icon}
                    alt="icon"
                  />
                </span>
              )}

              <p className="text-black font-weight-semibold d-block">
                {caseInfo?.case_type?.name || "N/A"}
              </p>
            </div>
            <div className="d-flex align-items-center" style={{ height: "21px" }}>
              <span
                className="ic-avatar ic-19 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center"
                style={{ marginRight: "5px" }}
              >
                <img
                  src={incidentIcon}
                  className=""
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                />
              </span>

              <p className="font-weight-semibold">
                {formatCalendarDate(caseInfo?.incident_date) || "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="m-t-5">
          <div
            className="tile-row d-flex align-items-center justify-content-between p-l-5 p-r-5"
            style={{ minHeight: "21px", background: "var(--primary-2)", fontWeight: 600 }}
          >
            <span className="text-label text-primary-25">Uploaded:</span>
            <span>
              {formatCalendarDate(
                documentData.created || documentData.uploaded_at || documentData.date_uploaded
              ) || "—"}
            </span>
          </div>
          <DocumentRenameComponent docId={docId} refetchDocumentData={refetchDocumentData} />
        </div>
        <div className="basic-info m-r-0 m-l-0">
          {/* Basic info content */}

          {/* Other basic info fields */}
          <span
            className="color-main m-t-5 text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            DOCUMENT LOCATION
          </span>
          <div
            className="d-flex align-items-center justify-content-between m-b-0"
            style={{
              background: "white",
              minHeight: "21px",
              maxHeight: locationMaxHeight,
            }}
          >
            <div
              className="tile-row d-flex align-items-center justify-content-start flex-wrap w-100 align-items-center"
              style={{
                minHeight: "21px",
                maxHeight: locationMaxHeight,
                overflow: "hidden",
                overflowWrap: "break-word", // ensures wrapping inside
                whiteSpace: "normal", // allows wrapping of long words
              }}
            >
              <PageInfo
                page={matchingSlot?.page || {}}
                documentSlot={matchExactSlott?.document_slot}
                panel={panelWithDocument}
                file_name={file_name}
                clientInfo={clientInfo}
              />
            </div>
          </div>
        </div>
        <div className="">
          <span
            className="color-main text-center text-color-heading d-flex align-items-center justify-content-center document-pop-up-menu-title"
            style={{
              fontSize: "14px",
              height: "25px",
              borderRadius: "0px",
            }}
          >
            MOVE DOCUMENT
          </span>

          {loading ? (
            <div>
              <style>{`
               @keyframes shimmer {
                 0% {
                   background-position: -1000px 0;
                 }
                 100% {
                   background-position: 1000px 0;
                 }
               }
               .shimmer-effect {
                 animation: shimmer 2s infinite linear;
                 background: linear-gradient(
                   90deg,
                   transparent 0%,
                   rgba(255, 255, 255, 0.3) 50%,
                   transparent 100%
                 );
                 background-size: 1000px 100%;
               }
             `}</style>

              <ul
                className="d-flex document-pop-up-menu-sidebar"
                style={{ paddingLeft: "0px", flexDirection: "row" }}
              >
                <div
                  style={{
                    flex: "1",
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((index) => (
                    <li key={index} className="">
                      <a
                        className="cursor-pointer d-flex align-items-center shimmer-effect relative overflow-hidden"
                        style={{
                          height: width > 2120 ? "21px" : "21px",
                          backgroundColor:
                            index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                        }}
                      >
                        <div
                          className="absolute inset-0"
                          style={{
                            animation: "shimmer 2s infinite linear",
                            background:
                              "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                            backgroundSize: "1000px 100%",
                          }}
                        />
                      </a>
                    </li>
                  ))}
                </div>

                <div
                  style={{
                    flex: "1",
                  }}
                >
                  {[10, 11, 12, 13, 14, 15, 16, 17, 18].map((index) => (
                    <li key={index} className="">
                      <a
                        className="cursor-pointer d-flex align-items-center shimmer-effect relative overflow-hidden"
                        style={{
                          height: width > 2120 ? "21px" : "21px",
                          backgroundColor:
                            index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                        }}
                      >
                        <div
                          className="absolute inset-0"
                          style={{
                            animation: "shimmer 2s infinite linear",
                            background:
                              "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                            backgroundSize: "1000px 100%",
                          }}
                        />
                      </a>
                    </li>
                  ))}
                </div>
              </ul>
            </div>
          ) : (
            <ul
              className="d-flex document-pop-up-menu-sidebar"
              style={{ paddingLeft: "0px", flexDirection: "row" }}
            >
              <div
                style={{
                  flex: "1",
                }}
              >
                {leftCol &&
                  leftCol.map((page, _index) => {
                    // Find the corresponding slot data for the current page
                    const slotData = slotsData.find((slot) => slot.page.name === page.name);
                    if (page.is_notes_category && slotData && slotData.slots?.length > 0) {
                      const { panels, slots: page_slots } = slotData;

                      if (page.id === 19) {
                        return (
                          <LitigationDocumentMenu
                            key={page.id}
                            page={page}
                            panels={panels}
                            inactivePanels={slotData.inactive_panels || []}
                            slots={page_slots}
                            showMenuBar={showMenuBar}
                            setShowMenuBar={setShowMenuBar}
                            onAttach={handleAttachLitigationDocument}
                          />
                        );
                      }

                      // If panels exist, show panels first

                      if (page_slots.length > 0 && page.name === "Treatment" && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "35px",
                                    // padding: "0 10px",
                                    paddingTop: "0px",
                                    paddingLeft: "25px",
                                    paddingRight: "10px",
                                    paddingBottom: "0px",
                                    // background: "white",
                                    cursor: "pointer",
                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="bg-primary-5 d-flex align-items-center"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "capitalize",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center color-grey-2"
                                    style={{ gap: "0px", width: "100%" }}
                                  >
                                    {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {panelIndex + 1}
                                    </span>
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      <img
                                        src={TFIcon}
                                        alt="tf-icon"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                          position: "relative",
                                          right: "0px",
                                          bottom: "0px",
                                        }}
                                      />
                                    </span>

                                    <span
                                      className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        width: "calc(100% - 25px)",
                                        background: mixColorWithWhite(panel?.specialty?.color, 10),
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: panel?.specialty?.color,

                                          fontSize: "16px",
                                          fontWeight: "700",
                                          height: "25px",
                                          width: "25px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                          marginRight: "5px",
                                        }}
                                      >
                                        {panel?.specialty?.name[0] ?? ""}
                                      </span>
                                      {panel?.panel_name ? panel.panel_name : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "250px",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right: "91%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                          background: documentData
                                            ? mixColorWithWhite(
                                                documentPanelsData?.specialty?.color,
                                                10
                                              )
                                            : "",
                                        }}
                                      >
                                        <span
                                          style={{
                                            background: documentPanelsData?.specialty?.color,
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            height: "25px",
                                            width: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            marginRight: "5px",
                                          }}
                                        >
                                          {documentPanelsData?.specialty?.name[0] ?? ""}
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );
                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });
                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              background:
                                                slotIndex % 2 === 0
                                                  ? mixColorWithWhite(panel?.specialty?.color, 2)
                                                  : mixColorWithWhite(panel?.specialty?.color, 4),
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-15 ic-file-colored cursor-pointer "
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center whitespace-nowrap  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",

                                                  // height: "25px",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="bg-primary-5 d-flex align-items-center"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center color-grey-2"
                                    style={{ gap: "0px", width: "100%" }}
                                  >
                                    {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {panelIndex + 1}
                                    </span>
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {/* <img
                                        src={TFIcon}
                                        alt="tf-icon"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                          position: "relative",
                                          right: "0px",
                                          bottom: "0px",
                                        }}
                                      /> */}
                                    </span>

                                    <span
                                      className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        width: "calc(100% - 25px)",
                                        background: mixColorWithWhite(panel?.specialty?.color, 10),
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a>
                                  {/* <a
                                    className="cursor-pointer d-flex align-items-center"
                                    // style={{ gap: "5px" }}
                                    style={{
                                      color: "var(--primary-25)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <span className="ms-2" style={{ fontWeight: "bold" }}>
                                      {panelIndex + 1}.
                                    </span>
                                    <span
                                      className="ms-2 whitespace-nowrap"
                                      style={{
                                        fontWeight: "bold",
                                        color: "var(--primary)",
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a> */}
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "auto",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right: "88%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="p-l-5 d-flex align-items-center"
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          <img
                                            src={page.page_icon ?? ""}
                                            className=" d-flex align-items-center justify-content-center cursor-pointer"
                                            // className="document-icons-width"
                                            alt=""
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        // const matchingSlot = previousSlotData.find((item) =>
                                        //   item.slots?.some((slot) =>
                                        //     slot.docs?.some((doc) => doc.id === documentData.id)
                                        //   )
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });

                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            // const hasDocument = currentSlot.page_docs?.some(
                                            //   (doc) => doc.id === documentData.id
                                            // );
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-15 ic-file-colored cursor-pointer "
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}
                                            {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  // height: "25px",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text whitespace-nowrap">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      if (page_slots.length > 0 && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              {/* <span
                                style={{
                                  display: "inline-block",
                                  width: "17px",
                                  height: "17px",
                                  color: "#19395F",
                                  transform: "rotate(180deg)",
                                  backgroundImage:
                                    showMenuBar === index
                                      ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                      : "",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                }}
                              ></span> */}
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="bg-primary-5 d-flex align-items-center"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center"
                                    // style={{ gap: "5px" }}
                                    style={{
                                      color: "var(--primary-25)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <span className="ms-2" style={{ fontWeight: "bold" }}>
                                      {panelIndex + 1}.
                                    </span>
                                    <span
                                      className="ms-2 whitespace-nowrap"
                                      style={{
                                        fontWeight: "bold",
                                        color: "var(--primary)",
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "auto",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right:
                                        page?.name === "Employment"
                                          ? "89%"
                                          : page?.name === "Reports"
                                            ? "88%"
                                            : page?.name === "Defendants"
                                              ? "89%"
                                              : page?.name === "Insurance"
                                                ? "93%"
                                                : page?.name === "Experts"
                                                  ? "88%"
                                                  : "90%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="p-l-5 d-flex align-items-center"
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          <img
                                            src={page.page_icon ?? ""}
                                            className=" d-flex align-items-center justify-content-center cursor-pointer"
                                            // className="document-icons-width"
                                            alt=""
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        // const matchingSlot = previousSlotData.find((item) =>
                                        //   item.slots?.some((slot) =>
                                        //     slot.docs?.some((doc) => doc.id === documentData.id)
                                        //   )
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });

                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            // const hasDocument = currentSlot.page_docs?.some(
                                            //   (doc) => doc.id === documentData.id
                                            // );
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-file-colored ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}
                                            {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  // height: "25px",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text whitespace-nowrap">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      // If no panels, show page slots directly
                      if (page_slots.length > 0 && !page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                // top:
                                //   width < 1920
                                //     ? `${index * 2 + 30}%`
                                //     : `${10 + index * 1.5}%`,
                                left: "auto",
                                top: "auto",
                                minWidth: "auto",
                                transform:
                                  width > 1920
                                    ? "translate(10px, -20px)"
                                    : "translate(10px, -20px)",
                                right: width > 1920 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);

                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot,
                                    };

                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });

                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.docs?.some((doc) => doc.id === documentData?.id)
                                    );

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    docs: [
                                                      ...(panel.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: s.docs
                                                    ? [...s.docs, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        slot: slot.id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: false,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}

                              {page_slots
                                .filter((slot) => slot.slot_number !== 0)
                                .map((slot, slotIndex) => {
                                  // const docsInSlot = slotData.page_docs?.filter(
                                  //   (doc) => doc.document_slot?.slot_number === slot?.slot_number
                                  // );
                                  const docsInSlot =
                                    slotData.slots
                                      ?.find((s) => s.slot_number === slot?.slot_number)
                                      ?.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      ) || [];

                                  const handleClick = async () => {
                                    const previousSlotData = slotsData;
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot,
                                    };
                                    // const matchingSlot = previousSlotData.find((slot) =>
                                    //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                    // );

                                    // const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                    //   panel.documents?.some((doc) => doc.id === documentData?.id)
                                    // );
                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });
                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.docs?.some((doc) => doc.id === documentData?.id)
                                    );
                                    // const updatedSlotsData = slotsData.map((currentSlot) => {
                                    //   if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                    //     const hasDocument = currentSlot.page_docs?.some(
                                    //       (doc) => doc.id === documentData.id
                                    //     );

                                    //     const hasPanel = currentSlot.panels?.some((panel) =>
                                    //       panel.documents?.some((doc) => doc.id === documentData.id)
                                    //     );

                                    //     if (hasPanel) {
                                    //       return {
                                    //         ...currentSlot,
                                    //         page_docs:
                                    //           currentSlot.page_docs?.filter(
                                    //             (doc) => doc.id !== documentData.id
                                    //           ) || [],
                                    //         panels:
                                    //           currentSlot.panels?.map((panel) => {
                                    //             if (panel.id === panelWithDocument?.id) {
                                    //               return {
                                    //                 ...panel,
                                    //                 documents: [
                                    //                   ...(panel.documents?.filter(
                                    //                     (doc) => doc.id !== documentData.id
                                    //                   ) || []),
                                    //                 ],
                                    //               };
                                    //             }
                                    //             return panel;
                                    //           }) || [],
                                    //       };
                                    //     } else if (hasDocument) {
                                    //       const filteredDocs = currentSlot.page_docs.filter(
                                    //         (doc) => doc.id !== documentData.id
                                    //       );

                                    //       return {
                                    //         ...currentSlot,
                                    //         page_docs: filteredDocs,
                                    //       };
                                    //     }
                                    //   }

                                    //   return currentSlot;
                                    // });

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    docs: [
                                                      ...(panel.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.id === slot.id) {
                                                return {
                                                  ...s,
                                                  docs: s.docs
                                                    ? [...s.docs, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        slot: slot.id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: false,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  };

                                  return (
                                    <li
                                      key={slotIndex}
                                      className="d-flex align-items-center"
                                      style={{
                                        height: "25px",
                                        cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                        padding: "0px 10px",
                                      }}
                                      onClick={handleClick}
                                    >
                                      {slot.slot_number !== 0 && (
                                        <span className="d-flex align-items-center justify-content-center">
                                          {docsInSlot.length > 0 ? (
                                            <i
                                              className="ic ic-15 ic-file-colored cursor-pointer "
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={UploadIcon}
                                              className=" ic-15 cursor-pointer"
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          )}
                                        </span>
                                      )}

                                      {/* {slot.slot_number === 0 && (
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                        
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    )} */}

                                      {slot.slot_number !== 0 && (
                                        <div
                                          className={`d-flex align-items-center  ${
                                            docsInSlot.length === 0 ? "hoverable-text" : ""
                                          }`}
                                          style={{
                                            width: "calc(100% - 25px)",
                                            fontWeight: "bold",
                                            color:
                                              docsInSlot.length === 0
                                                ? "var(--primary-25)"
                                                : "inherit",
                                          }}
                                        >
                                          <>
                                            <span className="ms-2 hoverable-text">
                                              {slot.slot_number}.
                                            </span>
                                            <span className="ms-2 hoverable-text whitespace-nowrap">
                                              {docsInSlot.length > 0
                                                ? docsInSlot[0].file_name
                                                : slot.slot_name
                                                  ? slot.slot_name
                                                  : "Available"}
                                            </span>
                                          </>
                                        </div>
                                      )}
                                    </li>
                                  );
                                })}
                            </ul>
                          </li>
                        );
                      }
                    }

                    return null;
                  })}
              </div>
              <div
                style={{
                  flex: "1",
                }}
              >
                {rightCol &&
                  rightCol.map((page, _index) => {
                    // Find the corresponding slot data for the current page
                    const slotData = slotsData.find((slot) => slot.page.name === page.name);
                    if (page.is_notes_category && slotData && slotData.slots?.length > 0) {
                      const { panels, slots: page_slots } = slotData;

                      if (page.id === 19) {
                        return (
                          <LitigationDocumentMenu
                            key={page.id}
                            page={page}
                            panels={panels}
                            inactivePanels={slotData.inactive_panels || []}
                            slots={page_slots}
                            showMenuBar={showMenuBar}
                            setShowMenuBar={setShowMenuBar}
                            onAttach={handleAttachLitigationDocument}
                          />
                        );
                      }

                      // If panels exist, show panels first

                      if (page_slots.length > 0 && page.name === "Treatment" && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "35px",
                                    // padding: "0 10px",
                                    paddingTop: "0px",
                                    paddingLeft: "25px",
                                    paddingRight: "10px",
                                    paddingBottom: "0px",
                                    // background: "white",
                                    cursor: "pointer",
                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="d-flex align-items-center bg-primary-5"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "capitalize",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center color-grey-2"
                                    style={{ gap: "0px", width: "100%" }}
                                  >
                                    {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {panelIndex + 1}
                                    </span>
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      <img
                                        src={TFIcon}
                                        alt="tf-icon"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                          position: "relative",
                                          right: "0px",
                                          bottom: "0px",
                                        }}
                                      />
                                    </span>

                                    <span
                                      className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        width: "calc(100% - 25px)",
                                        background: mixColorWithWhite(panel?.specialty?.color, 10),
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: panel?.specialty?.color,

                                          fontSize: "16px",
                                          fontWeight: "700",
                                          height: "25px",
                                          width: "25px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          color: "white",
                                          marginRight: "5px",
                                        }}
                                      >
                                        {panel?.specialty?.name[0] ?? ""}
                                      </span>
                                      {panel?.panel_name ? panel.panel_name : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "250px",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right: "91%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                          background: documentData
                                            ? mixColorWithWhite(
                                                documentPanelsData?.specialty?.color,
                                                10
                                              )
                                            : "",
                                        }}
                                      >
                                        <span
                                          style={{
                                            background: documentPanelsData?.specialty?.color,
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            height: "25px",
                                            width: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            color: "white",
                                            marginRight: "5px",
                                          }}
                                        >
                                          {documentPanelsData?.specialty?.name[0] ?? ""}
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );
                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });
                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              background:
                                                slotIndex % 2 === 0
                                                  ? mixColorWithWhite(panel?.specialty?.color, 2)
                                                  : mixColorWithWhite(panel?.specialty?.color, 4),
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-15 ic-file-colored cursor-pointer "
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center whitespace-nowrap  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",

                                                  // height: "25px",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      if (page_slots.length > 0 && page.panels && page.name === "Loans") {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="d-flex align-items-center bg-primary-5"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center color-grey-2"
                                    style={{ gap: "0px", width: "100%" }}
                                  >
                                    {/* <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    ></span> */}
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {panelIndex + 1}
                                    </span>
                                    <span
                                      className=" d-flex align-items-center justify-content-center"
                                      style={{
                                        fontWeight: "bold",
                                        width: "25px",
                                        height: "25px",
                                        color: "var(--primary-25)",
                                      }}
                                    >
                                      {/* <img
                                        src={TFIcon}
                                        alt="tf-icon"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                          position: "relative",
                                          right: "0px",
                                          bottom: "0px",
                                        }}
                                      /> */}
                                    </span>

                                    <span
                                      className="d-flex align-items-center p-r-5 whitespace-nowrap"
                                      style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        width: "calc(100% - 25px)",
                                        background: mixColorWithWhite(panel?.specialty?.color, 10),
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a>
                                  {/* <a
                                    className="cursor-pointer d-flex align-items-center"
                                    // style={{ gap: "5px" }}
                                    style={{
                                      color: "var(--primary-25)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <span className="ms-2" style={{ fontWeight: "bold" }}>
                                      {panelIndex + 1}.
                                    </span>
                                    <span
                                      className="ms-2 whitespace-nowrap"
                                      style={{
                                        fontWeight: "bold",
                                        color: "var(--primary)",
                                      }}
                                    >
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a> */}
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "auto",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right: "88%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="p-l-5 d-flex align-items-center"
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          <img
                                            src={page.page_icon ?? ""}
                                            className=" d-flex align-items-center justify-content-center cursor-pointer"
                                            // className="document-icons-width"
                                            alt=""
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        // const matchingSlot = previousSlotData.find((item) =>
                                        //   item.slots?.some((slot) =>
                                        //     slot.docs?.some((doc) => doc.id === documentData.id)
                                        //   )
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });

                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            // const hasDocument = currentSlot.page_docs?.some(
                                            //   (doc) => doc.id === documentData.id
                                            // );
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-15 ic-file-colored cursor-pointer "
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}
                                            {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  // height: "25px",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text whitespace-nowrap">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      if (page_slots.length > 0 && page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              {/* <span
                                style={{
                                  display: "inline-block",
                                  width: "17px",
                                  height: "17px",
                                  color: "#19395F",
                                  transform: "rotate(180deg)",
                                  backgroundImage:
                                    showMenuBar === index
                                      ? `url("data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A")`
                                      : "",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                }}
                              ></span> */}
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                top: "auto",
                                // page.name === "Witnesses"
                                //   ? `${index * 2 + 3}%`
                                //   : "auto",
                                left: "auto",
                                minWidth: "auto",
                                transform: "translate(10px, -20px)",
                                right: width > 1400 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot ?? {},
                                    };

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (
                                        currentSlot?.page?.id ===
                                        documentData?.document_slot?.page?.id
                                      ) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasDocument || hasPanel) {
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => ({
                                                ...panel,
                                                docs:
                                                  panel.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          // page_docs: [
                                          //   ...(currentSlot.page_docs || []),
                                          //   updatedDocumentData,
                                          // ],
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: [...(s.docs || []), updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          panels:
                                            currentSlot.panels?.map((panel) => ({
                                              ...panel,
                                              docs: [...(panel.docs || [])],
                                            })) || [],
                                        };
                                      }

                                      return currentSlot;
                                    });
                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        panel_id: "",
                                        slot: page_slots.find((slot) => slot.slot_number === 0).id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: true,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error("Error attaching document to slot 0", error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}
                              <div
                                className="d-flex align-items-center bg-primary-5"
                                style={{
                                  // paddingLeft: "55px",
                                  height: "25px",
                                  padding: "0 10px",
                                  // background: "var(--primary-15)",
                                }}
                              >
                                <span
                                  className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    color: "var(--primary)",
                                    width: "100%",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {page?.panel_name}
                                </span>
                              </div>
                              {panels?.length === 0 && (
                                <li
                                  className="d-flex align-items-center"
                                  style={{
                                    // paddingLeft: "55px",
                                    height: "50px",
                                    padding: "0 10px",
                                    background: "var(--primary-2)",
                                  }}
                                >
                                  <span
                                    className="d-flex align-items-center justify-content-center whitespace-nowrap"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      color: "var(--primary-25)",
                                      width: "100%",
                                      // textTransform: "",
                                    }}
                                  >
                                    {toSentenceCase(`No ${page?.panel_name}`)}
                                  </span>
                                </li>
                              )}
                              {panels.map((panel, panelIndex) => (
                                <li
                                  key={panelIndex}
                                  className="d-flex align-items-center"
                                  style={{
                                    // padding: "0px 10px",
                                    height: "25px",
                                  }}
                                  onMouseEnter={() => {
                                    setDocumentPanelsData(panel);
                                    setPanelMenuBar(panelIndex);
                                  }}
                                  onMouseLeave={() => {
                                    setDocumentPanelsData([]);
                                    setPanelMenuBar(null);
                                  }}
                                >
                                  <a
                                    className="cursor-pointer d-flex align-items-center"
                                    // style={{ gap: "5px" }}
                                    style={{
                                      color: "var(--primary-25)",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          panelMenuBar === panelIndex
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                      }}
                                    />
                                    <span className="ms-2" style={{ fontWeight: "bold" }}>
                                      {panelIndex + 1}.
                                    </span>
                                    <span
                                      className="ms-2 whitespace-nowrap"
                                      style={{
                                        fontWeight: "bold",
                                        color: "var(--primary)",
                                      }}
                                    >
                                      {panel?.event_type_id?.litigation_event_type &&
                                        `${panel?.event_type_id?.litigation_event_type} `}
                                      {page?.name === "Offer" ? panel?.panel_name : ""}
                                      {page?.name !== "Offer"
                                        ? panel?.specialty
                                          ? panel?.specialty.name
                                          : panel?.panel_name
                                            ? panel?.panel_name
                                            : ""
                                        : ""}
                                    </span>
                                  </a>
                                  <ul
                                    className="document-pop-up-sidebar-menubar"
                                    style={{
                                      position: "absolute",
                                      // left: "auto",
                                      top:
                                        width < 1400
                                          ? `${panelIndex * 2 + 18}%`
                                          : `${10 + panelIndex * 2}%`,
                                      left: "auto",
                                      // top: "auto",
                                      minWidth: "auto",
                                      transform:
                                        width > 1400
                                          ? `translate(0px, -${panelIndex + 15}%)`
                                          : `translate(0px, -${panelIndex + 30}%)`,
                                      // right: "17.2%",
                                      right:
                                        page?.name === "Employment"
                                          ? "89%"
                                          : page?.name === "Reports"
                                            ? "88%"
                                            : page?.name === "Defendants"
                                              ? "89%"
                                              : page?.name === "Insurance"
                                                ? "93%"
                                                : page?.name === "Experts"
                                                  ? "88%"
                                                  : "90%",
                                      display: panelMenuBar === panelIndex ? "block" : "",
                                      width: "max-content",
                                    }}
                                  >
                                    <li
                                      className="d-flex align-items-center"
                                      style={{
                                        padding: "0px",
                                        height: "25px",
                                      }}
                                    >
                                      <span
                                        className="d-flex align-items-center whitespace-nowrap p-r-5"
                                        style={{
                                          fontWeight: "600",
                                          fontSize: "14px",
                                          color: "black",
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="p-l-5 d-flex align-items-center"
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                          }}
                                        >
                                          <img
                                            src={page.page_icon ?? ""}
                                            className=" d-flex align-items-center justify-content-center cursor-pointer"
                                            // className="document-icons-width"
                                            alt=""
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                        </span>
                                        {documentPanelsData?.panel_name
                                          ? documentPanelsData.panel_name
                                          : ""}
                                      </span>
                                    </li>
                                    {page_slots.map((slot, slotIndex) => {
                                      const docsInSlot = panel.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      );
                                      const handleClick = async () => {
                                        const previousSlotData = slotsData;
                                        const updatedDocumentData = {
                                          ...documentData,
                                          document_slot: slot,
                                        };
                                        // const matchingSlot = previousSlotData.find((slot) =>
                                        //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                        // );
                                        // const matchingSlot = previousSlotData.find((item) =>
                                        //   item.slots?.some((slot) =>
                                        //     slot.docs?.some((doc) => doc.id === documentData.id)
                                        //   )
                                        // );
                                        const matchingSlot = previousSlotData.find((item) => {
                                          // Check in slots
                                          const inSlots = item.slots?.some((slot) =>
                                            slot.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          if (inSlots) return inSlots;

                                          const inPanels = item.panels?.some((panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData.id)
                                          );

                                          return inPanels;
                                        });

                                        // const panelWithDocument = matchingSlot?.panels?.find(
                                        //   (panel) => {
                                        //     panel.docs?.some((doc) => doc.id === documentData?.id);
                                        //   }
                                        // );
                                        const panelWithDocument = matchingSlot?.panels?.find(
                                          (panel) =>
                                            panel.docs?.some((doc) => doc.id === documentData?.id)
                                        );
                                        const updatedSlotsData = slotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                            // const hasDocument = currentSlot.page_docs?.some(
                                            //   (doc) => doc.id === documentData.id
                                            // );
                                            const hasDocument = currentSlot.slots?.some((slot) =>
                                              slot.docs?.some((doc) => doc.id === documentData.id)
                                            );
                                            const hasPanel = currentSlot.panels?.some((panel) =>
                                              panel.docs?.some((doc) => doc.id === documentData.id)
                                            );

                                            if (hasDocument || hasPanel) {
                                              return {
                                                ...currentSlot,
                                                // page_docs:
                                                //   currentSlot.page_docs?.filter(
                                                //     (doc) => doc.id !== documentData.id
                                                //   ) || [],
                                                slots:
                                                  currentSlot.slots?.map((slot) => ({
                                                    ...slot,
                                                    docs:
                                                      slot.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || [],
                                                  })) || [],
                                                panels:
                                                  currentSlot.panels?.map((panel) => {
                                                    if (panel.id === panelWithDocument?.id) {
                                                      return {
                                                        ...panel,
                                                        docs: [
                                                          ...(panel.docs?.filter(
                                                            (doc) => doc.id !== documentData.id
                                                          ) || []),
                                                        ],
                                                      };
                                                    }
                                                    return panel;
                                                  }) || [],
                                              };
                                            }
                                          }

                                          return currentSlot;
                                        });

                                        const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                          if (currentSlot?.page?.id === slot?.page?.id) {
                                            return {
                                              ...currentSlot,
                                              slots: [...(currentSlot.slots || [])],
                                              panels:
                                                currentSlot.panels?.map((panel) => {
                                                  if (panel.id === documentPanelsData?.id) {
                                                    return {
                                                      ...panel,
                                                      docs: [
                                                        ...(panel.docs || []),
                                                        updatedDocumentData,
                                                      ],
                                                    };
                                                  }
                                                  return panel;
                                                }) || [],
                                            };
                                          }

                                          return currentSlot;
                                        });

                                        try {
                                          setSlotsData(updatingSlot);
                                          await api_without_cancellation.post("api/doc/attach/", {
                                            panel_id: panel.id,
                                            slot: slot.id,
                                            page_id: page.id,
                                            case_id: documentData?.for_case?.id,
                                            panels: true,
                                            doc_id: docId,
                                            ...(panel?.event_type_id?.id && {
                                              event_type_id: panel?.event_type_id?.id,
                                            }),
                                          });
                                          if (typeof refetchDocumentData === "function") {
                                            await refetchDocumentData();
                                          }
                                          onRefetchSlotsData();
                                        } catch (error) {
                                          console.error(error);
                                          setSlotsData(previousSlotData);
                                        }
                                      };

                                      return (
                                        slot.slot_number !== 0 && (
                                          <li
                                            key={slotIndex}
                                            className="d-flex align-items-center"
                                            style={{
                                              padding: "0px 10px",
                                              height: "25px",
                                              cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                            }}
                                            onClick={handleClick}
                                          >
                                            {slot.slot_number !== 0 && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                {docsInSlot.length > 0 ? (
                                                  <i
                                                    className="ic ic-file-colored ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={UploadIcon}
                                                    className=" ic-15 cursor-pointer"
                                                    style={{
                                                      backgroundRepeat: "no-repeat",
                                                    }}
                                                  />
                                                )}
                                              </span>
                                            )}
                                            {/* 
                                        {slot.slot_number === 0 && (
                                          <span className="d-flex align-items-center ms-2">
                                            <img
                                              src={page.page_icon ?? ""}
                                              className="document-icons-width  cursor-pointer m-r-5"
                                              alt=""
                                            />
                                            Attach to {page.name} Page
                                          </span>
                                        )} */}

                                            {slot.slot_number !== 0 && (
                                              <div
                                                className={`d-flex align-items-center  ${
                                                  docsInSlot.length === 0 ? "hoverable-text" : ""
                                                }`}
                                                style={{
                                                  width: "calc(100% - 25px)",
                                                  fontWeight: "bold",
                                                  // height: "25px",
                                                  color:
                                                    docsInSlot.length === 0
                                                      ? "var(--primary-25)"
                                                      : "inherit",
                                                }}
                                              >
                                                <>
                                                  <span className="ms-2 hoverable-text">
                                                    {slot.slot_number}.
                                                  </span>
                                                  <span className="ms-2 hoverable-text whitespace-nowrap">
                                                    {docsInSlot.length > 0
                                                      ? docsInSlot[0].file_name
                                                      : slot.slot_name
                                                        ? slot.slot_name
                                                        : "Available"}
                                                  </span>
                                                </>
                                              </div>
                                            )}
                                          </li>
                                        )
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      }

                      // If no panels, show page slots directly
                      if (page_slots.length > 0 && !page.panels) {
                        return (
                          <li
                            key={page?.id}
                            className=""
                            onMouseEnter={() => setShowMenuBar(page?.id)}
                            onMouseLeave={() => setShowMenuBar(null)}
                            style={{
                              position: "relative",
                            }}
                          >
                            <a
                              className="cursor-pointer d-flex align-items-center"
                              style={{
                                gap: "5px",
                                height: "21px",
                                fontWeight: "bold",
                                paddingLeft: "5px",
                              }}
                            >
                              <img
                                src={page.page_icon ?? ""}
                                className="doc-pop-width-15px-height-15px-2"
                                style={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                              {page.name}
                              <span className="caret" />
                            </a>
                            <ul
                              className="document-pop-up-sidebar-menubar"
                              style={{
                                position: "absolute",
                                // left: "auto",
                                // top:
                                //   width < 1920
                                //     ? `${index * 2 + 30}%`
                                //     : `${10 + index * 1.5}%`,
                                left: "auto",
                                top: "auto",
                                minWidth: "auto",
                                transform:
                                  width > 1920
                                    ? "translate(10px, -20px)"
                                    : "translate(10px, -20px)",
                                right: width > 1920 ? "120px" : "120px",
                                display: showMenuBar === page?.id ? "block" : "",
                                width: "max-content",
                                zIndex: 2,
                              }}
                            >
                              {page_slots.find((slot) => slot.slot_number === 0) && (
                                <li
                                  className="d-flex align-items-center background-white-hover-primary-four"
                                  style={{
                                    padding: "0px 10px 0px 25px",
                                    height: "35px",
                                    cursor: "pointer",
                                    // background: "white",

                                    color: "var(--primary)",

                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize",
                                  }}
                                  onClick={async () => {
                                    const previousSlotData = slotsData;
                                    const slot = page_slots.find((slot) => slot?.slot_number === 0);

                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot,
                                    };

                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });

                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.docs?.some((doc) => doc.id === documentData?.id)
                                    );

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    docs: [
                                                      ...(panel.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.slot_number === 0) {
                                                return {
                                                  ...s,
                                                  docs: s.docs
                                                    ? [...s.docs, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        slot: slot.id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: false,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  }}
                                >
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "100%" }}
                                  >
                                    <span
                                      className="d-flex align-items-center whitespace-nowrap "
                                      style={{ fontWeight: "bold" }}
                                    >
                                      <span
                                        className="m-r-5 d-flex align-items-center"
                                        style={{
                                          width: "29px",
                                          height: "29px",
                                        }}
                                      >
                                        <img
                                          src={page.page_icon ?? ""}
                                          className=" d-flex align-items-center justify-content-center cursor-pointer"
                                          // className="document-icons-width"
                                          alt=""
                                          style={{
                                            width: "29px",
                                            height: "29px",
                                          }}
                                        />
                                      </span>
                                      Attach to {page.name} Page
                                    </span>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "17px",
                                        height: "17px",
                                        color: "#19395F",
                                        transform: "rotate(180deg)",
                                        backgroundImage:
                                          showMenuBar === page?.id
                                            ? "url(\"data:image/svg+xml,<svg width='17' height='17' viewBox='0 0 17 34' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.00634766 33.9993L0.00634766 24.7993L7.8602 16.9992L0.00634766 9.19912L0.00634766 -0.000884091L17.0063 16.9992L0.00634766 33.9993Z' fill='%2319395f'/></svg>%0A\")"
                                            : "",
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "contain",
                                        marginRight: "-10px",
                                      }}
                                    />
                                  </div>
                                </li>
                              )}

                              {page_slots
                                .filter((slot) => slot.slot_number !== 0)
                                .map((slot, slotIndex) => {
                                  // const docsInSlot = slotData.page_docs?.filter(
                                  //   (doc) => doc.document_slot?.slot_number === slot?.slot_number
                                  // );
                                  const docsInSlot =
                                    slotData.slots
                                      ?.find((s) => s.slot_number === slot?.slot_number)
                                      ?.docs?.filter(
                                        (doc) =>
                                          doc.document_slot?.slot_number === slot?.slot_number
                                      ) || [];

                                  const handleClick = async () => {
                                    const previousSlotData = slotsData;
                                    const updatedDocumentData = {
                                      ...documentData,
                                      document_slot: slot,
                                    };
                                    // const matchingSlot = previousSlotData.find((slot) =>
                                    //   slot.page_docs?.some((doc) => doc.id === documentData.id)
                                    // );

                                    // const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                    //   panel.documents?.some((doc) => doc.id === documentData?.id)
                                    // );
                                    const matchingSlot = previousSlotData.find((item) => {
                                      // Check in slots
                                      const inSlots = item.slots?.some((slot) =>
                                        slot.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      if (inSlots) return inSlots;

                                      const inPanels = item.panels?.some((panel) =>
                                        panel.docs?.some((doc) => doc.id === documentData.id)
                                      );

                                      return inPanels;
                                    });
                                    const panelWithDocument = matchingSlot?.panels?.find((panel) =>
                                      panel.docs?.some((doc) => doc.id === documentData?.id)
                                    );
                                    // const updatedSlotsData = slotsData.map((currentSlot) => {
                                    //   if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                    //     const hasDocument = currentSlot.page_docs?.some(
                                    //       (doc) => doc.id === documentData.id
                                    //     );

                                    //     const hasPanel = currentSlot.panels?.some((panel) =>
                                    //       panel.documents?.some((doc) => doc.id === documentData.id)
                                    //     );

                                    //     if (hasPanel) {
                                    //       return {
                                    //         ...currentSlot,
                                    //         page_docs:
                                    //           currentSlot.page_docs?.filter(
                                    //             (doc) => doc.id !== documentData.id
                                    //           ) || [],
                                    //         panels:
                                    //           currentSlot.panels?.map((panel) => {
                                    //             if (panel.id === panelWithDocument?.id) {
                                    //               return {
                                    //                 ...panel,
                                    //                 documents: [
                                    //                   ...(panel.documents?.filter(
                                    //                     (doc) => doc.id !== documentData.id
                                    //                   ) || []),
                                    //                 ],
                                    //               };
                                    //             }
                                    //             return panel;
                                    //           }) || [],
                                    //       };
                                    //     } else if (hasDocument) {
                                    //       const filteredDocs = currentSlot.page_docs.filter(
                                    //         (doc) => doc.id !== documentData.id
                                    //       );

                                    //       return {
                                    //         ...currentSlot,
                                    //         page_docs: filteredDocs,
                                    //       };
                                    //     }
                                    //   }

                                    //   return currentSlot;
                                    // });

                                    const updatedSlotsData = slotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === matchingSlot?.page?.id) {
                                        // const hasDocument = currentSlot.page_docs?.some(
                                        //   (doc) => doc.id === documentData.id
                                        // );
                                        const hasDocument = currentSlot.slots?.some((slot) =>
                                          slot.docs?.some((doc) => doc.id === documentData.id)
                                        );

                                        const hasPanel = currentSlot.panels?.some((panel) =>
                                          panel.docs?.some((doc) => doc.id === documentData.id)
                                        );
                                        if (hasPanel) {
                                          return {
                                            ...currentSlot,
                                            // page_docs:
                                            //   currentSlot.page_docs?.filter(
                                            //     (doc) => doc.id !== documentData.id
                                            //   ) || [],
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                            panels:
                                              currentSlot.panels?.map((panel) => {
                                                if (panel.id === panelWithDocument?.id) {
                                                  return {
                                                    ...panel,
                                                    docs: [
                                                      ...(panel.docs?.filter(
                                                        (doc) => doc.id !== documentData.id
                                                      ) || []),
                                                    ],
                                                  };
                                                }
                                                return panel;
                                              }) || [],
                                          };
                                        } else if (hasDocument) {
                                          // const filteredDocs = currentSlot.page_docs.filter(
                                          //   (doc) => doc.id !== documentData.id
                                          // );

                                          // return {
                                          //   ...currentSlot,
                                          //   slots: filteredDocs,
                                          // };
                                          return {
                                            ...currentSlot,
                                            slots:
                                              currentSlot.slots?.map((slot) => ({
                                                ...slot,
                                                docs:
                                                  slot.docs?.filter(
                                                    (doc) => doc.id !== documentData.id
                                                  ) || [],
                                              })) || [],
                                          };
                                        }
                                      }

                                      return currentSlot;
                                    });

                                    const updatingSlot = updatedSlotsData.map((currentSlot) => {
                                      if (currentSlot?.page?.id === slot?.page?.id) {
                                        return {
                                          ...currentSlot,
                                          slots:
                                            currentSlot.slots?.map((s) => {
                                              if (s.id === slot.id) {
                                                return {
                                                  ...s,
                                                  docs: s.docs
                                                    ? [...s.docs, updatedDocumentData]
                                                    : [updatedDocumentData],
                                                };
                                              }
                                              return s;
                                            }) || [],
                                          // page_docs: currentSlot.page_docs
                                          //   ? [...currentSlot.page_docs, updatedDocumentData]
                                          //   : [updatedDocumentData],
                                        };
                                      }

                                      return currentSlot;
                                    });

                                    try {
                                      setSlotsData(updatingSlot);
                                      await api_without_cancellation.post("api/doc/attach/", {
                                        slot: slot.id,
                                        page_id: page.id,
                                        case_id: documentData?.for_case?.id,
                                        panels: false,
                                        doc_id: docId,
                                      });
                                      if (typeof refetchDocumentData === "function") {
                                        await refetchDocumentData();
                                      }
                                      onRefetchSlotsData();
                                    } catch (error) {
                                      console.error(error);
                                      setSlotsData(previousSlotData);
                                    }
                                  };

                                  return (
                                    <li
                                      key={slotIndex}
                                      className="d-flex align-items-center"
                                      style={{
                                        height: "25px",
                                        cursor: docsInSlot.length > 0 ? "default" : "pointer",
                                        padding: "0px 10px",
                                      }}
                                      onClick={handleClick}
                                    >
                                      {slot.slot_number !== 0 && (
                                        <span className="d-flex align-items-center justify-content-center">
                                          {docsInSlot.length > 0 ? (
                                            <i
                                              className="ic ic-15 ic-file-colored cursor-pointer "
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={UploadIcon}
                                              className=" ic-15 cursor-pointer"
                                              style={{
                                                backgroundRepeat: "no-repeat",
                                              }}
                                            />
                                          )}
                                        </span>
                                      )}

                                      {/* {slot.slot_number === 0 && (
                                      <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="d-flex align-items-center whitespace-nowrap "
                                          style={{ fontWeight: "bold" }}
                                        >
                                        
                                          Attach to {page.name} Page
                                        </span>
                                      </div>
                                    )} */}

                                      {slot.slot_number !== 0 && (
                                        <div
                                          className={`d-flex align-items-center  ${
                                            docsInSlot.length === 0 ? "hoverable-text" : ""
                                          }`}
                                          style={{
                                            width: "calc(100% - 25px)",
                                            fontWeight: "bold",
                                            color:
                                              docsInSlot.length === 0
                                                ? "var(--primary-25)"
                                                : "inherit",
                                          }}
                                        >
                                          <>
                                            <span className="ms-2 hoverable-text">
                                              {slot.slot_number}.
                                            </span>
                                            <span className="ms-2 hoverable-text whitespace-nowrap">
                                              {docsInSlot.length > 0
                                                ? docsInSlot[0].file_name
                                                : slot.slot_name
                                                  ? slot.slot_name
                                                  : "Available"}
                                            </span>
                                          </>
                                        </div>
                                      )}
                                    </li>
                                  );
                                })}
                            </ul>
                          </li>
                        );
                      }
                    }

                    return null;
                  })}
              </div>

              {pages?.length === 0 &&
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((index) => (
                  <li key={index} className="">
                    <a
                      className="cursor-pointer d-flex align-items-center justify-content-center shimmer-effect relative overflow-hidden"
                      style={{
                        height: width > 2120 ? "25px" : "25px",
                        backgroundColor: index % 2 === 0 ? "var(--primary-2)" : "var(--primary-4)",
                      }}
                    >
                      <div
                        className="absolute inset-0"
                        style={{
                          animation: "shimmer 2s infinite linear",
                          background:
                            "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%)",
                          backgroundSize: "1000px 100%",
                        }}
                      >
                        {index === 7 && (
                          <span
                            style={{
                              color: "var(--primary-50)",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                            className="p-r-5"
                          >
                            Attach Document To Case First
                          </span>
                        )}
                      </div>
                    </a>
                  </li>
                ))}
            </ul>
          )}
        </div>

        <div
          className="document-sidebar-actions d-flex flex-column"
          style={{
            gap: height <= 1024 ? "8px" : "40px",
            ...(pages.length === 0 && {
              position: "relative",
              top: "50%",
              transform: "translateY(-50%)",
            }),
          }}
        >
          {/* {pages?.length === 0 && (
            <span className="document-sidebar-attach-notice" role="status">
              Attach Document To Case First
            </span>
          )} */}
          <div
            className="document-sidebar-primary-actions"
            style={{
              background: "white",
              padding: "5px",
              gap: "5px",
              display: height <= 1024 ? "flex" : "flex",
              justifyContent: height <= 1024 ? "space-between" : "initial",
              flexDirection: height <= 1024 ? "row" : "column",
              flexWrap: height <= 1024 ? "nowrap" : "nowrap",
            }}
          >
            {/* Chat Document Link Dropdown */}

            <div className="tile-row w-100  center-content my-auto">
              <div
                className="dropdown  d-flex justify-content-center align-items-cente"
                ref={dropdownRefs.chatDoc}
              >
                <button
                  className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.chatDoc ? "show" : ""}`}
                  type="button"
                  disabled={source === "chat"}
                  // onClick={() => toggleDropdown("chatDoc")}
                  onClick={source === "chat" ? () => {} : handleShow}
                  aria-haspopup="true"
                  aria-expanded={dropdownOpen.chatDoc}
                >
                  <span className="ic-15 d-flex align-items-center justify-content-center">
                    {/* <i className="ic ic-19 ic-chat-3d d-flex align-items-cente justify-content-center" /> */}
                    <NewChatIcon />
                  </span>
                  {isTreatment && height <= 1024 ? "" : height <= 1024 ? "" : "Chat About Document"}
                </button>
                {dropdownOpen.chatDoc && (
                  <div className="dropdown-menu show">{/* Add dropdown items here */}</div>
                )}
              </div>
            </div>

            {/* Request Document Review Button */}

            <div className="tile-row w-100 center-content my-auto">
              <div
                className="dropdown d-flex justify-content-center align-items-center"
                ref={dropdownRefs.docReview}
              >
                <button
                  className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.docReview ? "show" : ""}`}
                  type="button"
                  onClick={toggleModal}
                  aria-haspopup="true"
                  aria-expanded={dropdownOpen.docReview}
                >
                  <span className="ic-15 d-flex align-items-center justify-content-center">
                    <img
                      src="https://simplefirm-bucket.s3.amazonaws.com/static/images/Tasks_page_icon_color.svg"
                      className="ic ic-15 cursor-pointer d-flex align-items-center justify-content-center"
                    />
                  </span>
                  {isTreatment && height <= 1024 ? "" : height <= 1024 ? "" : "Request Doc Review"}
                  {/* {height <= 1024 ? "Review" : "Request Doc Review"} */}
                </button>
              </div>
            </div>

            <div className="tile-row w-100 center-content my-auto">
              <div
                className="dropdown d-flex justify-content-center align-items-cente"
                ref={dropdownRefs.addLib}
              >
                <button
                  className={
                    "btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn"
                  }
                  type="button"
                  onClick={() => handleDocToLib()}
                >
                  <span className="ic-15 d-flex align-items-center justify-content-center">
                    <i className="ic ic-15 ic-library cursor-pointer d-flex align-items-center justify-content-center" />
                  </span>
                  {isTreatment && height <= 1024 ? "" : height <= 1024 ? "" : "Add Doc to Library"}
                  {/* {height <= 1024 ? "Review" : "Request Doc Review"} */}
                </button>
              </div>
            </div>

            {isTreatment && (
              <div className="document-sidebar-ai-action tile-row w-100 center-content my-auto">
                <div className="dropdown d-flex justify-content-center align-items-cente">
                  <button
                    className={`btn height-25 bottom-sidebar-buttons-things  dropdown-toggle position-relative d-flex align-items-center justify-content-center w-100 form-select has-no-bg position-relative doc-rev-btn rotate-btn ${dropdownOpen.docReview ? "show" : ""}`}
                    type="button"
                    onClick={() => handleAISubmission()}
                    aria-haspopup="true"
                    disabled={documentData?.chronology_generated}
                    style={{
                      cursor: documentData?.chronology_generated ? "not-allowed" : "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center "
                      style={{
                        flexShrink: "0",
                      }}
                    >
                      <img
                        style={{
                          flexShrink: "0",
                        }}
                        src={powerbtn}
                        className="ic ic-15 d-flex align-items-center justify-content-center"
                      />
                    </span>
                    {isTreatment && height <= 1024
                      ? ""
                      : height <= 1024
                        ? ""
                        : "AI Chronology Extraction"}
                    {/* {height <= 1024 ? "Chrono" : "AI Chronology Extraction"} */}
                  </button>
                </div>
              </div>
            )}
          </div>
          <BottomContentSideBar
            docId={docId}
            caseId={caseId}
            clientId={clientId}
            setDeleteConfirmModal={setDeleteConfirmModal}
            refetchDocumentData={refetchDocumentData}
            height={height}
            isDisabled={isDisabled}
          />
        </div>
      </div>
      <RequestDocModal
        selectedDoc={docId}
        isOpen={isModalOpen}
        caseInfo={caseInfo}
        onConfirm={toggleModal}
        onClose={toggleModal}
      />
      <LinkDocToTaskModal
        showModal={showDocLinkModal}
        handleClose={handleShowDocLinkModalClose}
        userId={userId}
        caseId={caseId}
        docId={docId}
        clientId={clientId}
      />
      {aiSubmissionSuccess && (
        <ProgressModal
          show={aiSubmissionSuccess}
          onClose={() => setAISubmissionSuccess(false)}
          title="Success"
          message="Document has been sent to AI processing!"
          variant="success"
        />
      )}
      {aiSubmissionError && (
        <ProgressModal
          show={Boolean(aiSubmissionError)}
          onClose={() => setAISubmissionError("")}
          title="AI Processing Error"
          message={aiSubmissionError}
          variant="danger"
        />
      )}
      {librarySuccess && (
        <Modal show={librarySuccess} onHide={() => setLibrarySuccess(false)} centered size="md">
          <Modal.Header className="tfbp-modal-header">
            <Modal.Title className="tfbp-modal-title">Added to Library</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center" style={{ fontWeight: 600, fontSize: 14 }}>
            This document has been moved to the Library.
          </Modal.Body>
          <Modal.Footer style={{ border: 0, gap: 5, padding: "5px", justifyContent: "center" }}>
            <button
              type="button"
              className="btn btn-secondary d-flex align-items-center justify-content-center height-25"
              style={{ fontWeight: 600, fontSize: 14 }}
              onClick={() => setLibrarySuccess(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center height-25"
              style={{ fontWeight: 600, fontSize: 14 }}
              onClick={openLibraryViewer}
              disabled={!libraryDoc}
            >
              View in Library
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {showModal && (
        <ChatDocumentModal
          showModal={showModal}
          caseId={caseId}
          userId={userId}
          caseInfo={caseInfo}
          clientId={clientId}
          handleClose={handleClose}
          documentURL={documentURL}
          docName={file_name}
          documentData={documentData}
          firms={firms}
          selectedFirm={selectedFirm}
          users={users}
          loading={chatLoading}
          error={chatError}
          handleSelectFirm={handleSelectFirm}
          sendMessage={sendMessage}
          searchUsers={searchUsers}
          setChatDocumentThread={setChatDocumentThread}
          setUpdatedUser={setUpdatedUser}
          handleSelectUser={handleSelectUser}
        />
      )}
    </div>
  );
};

DocumentModalSideBar.propTypes = {
  documentData: PropTypes.shape({
    id: PropTypes.number.isRequired,
    for_client: PropTypes.object,
    for_case: PropTypes.shape({
      case_type: PropTypes.shape({
        name: PropTypes.string,
        casetype_icon: PropTypes.string,
      }),
      incident_date: PropTypes.string,
    }),
    file_name: PropTypes.string,
    docDate: PropTypes.string,
    attached_by: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      profile_pic_29p: PropTypes.string,
    }),
    document_slot: PropTypes.object,
  }).isRequired,
  pages: PropTypes.array.isRequired,
  slotsData: PropTypes.array.isRequired,
};

export default DocumentModalSideBar;
